import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SxProps } from '@mui/material/styles';
import dayjs from 'dayjs';

import { Control, Controller, FieldErrors } from "react-hook-form";

interface FormDateProps extends Omit<DatePickerProps<any>, 'renderInput'> {
    sx?: SxProps;
    control?: Control<any>;
    name?: string;
    label?: string;
    errors?: FieldErrors;
    onChange?: () => void;
    isISO?: boolean
    format?: string
    outputFormat?: string
    required?: boolean
    minDate?: dayjs.Dayjs
    maxDate?: dayjs.Dayjs
}

function FormDate({
    disabled,
    format = 'DD/MM/YYYY',
    isISO = false,
    outputFormat = 'MM-DD-YYYY',
    slotProps,
    sx = {width: '100%'},
    readOnly,
    control,
    name,
    label,
    errors,
    onChange,
    required,
    minDate,
    maxDate,
    ...props
}: FormDateProps) {
    const fieldError = name && errors ? errors[name] : undefined;

    if (control && name) {
        return (
            <div className="form-date">
                <label className="block text-sm font-medium mb-1 text-gray-700" htmlFor={name}>{label}{required ? <span className="text-red-500">*</span> : ''}</label>
                <Controller
                    name={name}
                    control={control}
                    render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                {...field}
                                value={field.value ? dayjs(field.value) : null}
                                onChange={(date) => onChange ? onChange() : field.onChange(date ? isISO ? dayjs(date).toISOString() : dayjs(date).format(outputFormat) : '')}
                                disabled={disabled}
                                format={format}
                                minDate={minDate ? dayjs(minDate) : undefined}
                                maxDate={maxDate ? dayjs(maxDate) : undefined}
                                slotProps={{
                                    ...slotProps,
                                    textField: {
                                        ...(slotProps?.textField || {}),
                                        error: !!fieldError,
                                        helperText: typeof fieldError === 'object' && fieldError?.message ? String(fieldError.message) : undefined,
                                    },
                                }}
                                sx={sx}
                                readOnly={readOnly}
                            // {...props}
                            />
                        </LocalizationProvider>
                    )}
                />
            </div>
        );
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disabled={disabled}
                format={format}
                slotProps={slotProps}
                sx={sx}
                readOnly={readOnly}
                {...props}
            />
        </LocalizationProvider>
    );
}

export default FormDate;
